<template>
  <div class="container">
    <navigation/>
    <div class="wrapper">
      Content goes here
    </div>
    <div class="center">
      <router-link tag="button" class="backBtn" to="/admin">Wróć na główną strone</router-link>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import navigation from '@/components/adminNav.vue';
export default {
  components:{
    Footer, navigation
  }
}
</script>

<style scoped lang="scss">
.backBtn{
  color: white;
  background: black;
  border: none;
  padding: 12px 24px;
  margin: 24px 0;
}
.center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrapper{
  margin-top: 120px;
}
.footer_container{
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>